import { isAxiosError } from "axios"

// Query defaults for the whole app (index.tsx). react-query's stock retry is
// 3 attempts with backoff (~7 s) for every error — so a 401/403/404, which
// no retry will change, kept a page on its spinner for seconds before showing
// the error (e.g. on the 1st of the month before the new month's summary
// exists). Client errors fail at once; server and network errors get up to
// two retries. Hooks that set their own `retry` keep it.
const RETRYABLE_CLIENT_STATUSES = new Set([408, 429])
const MAX_RETRIES = 2

export const defaultQueryRetry = (failureCount: number, error: unknown): boolean => {
  const status = isAxiosError(error) ? error.response?.status : undefined
  if (status !== undefined && status >= 400 && status < 500 && !RETRYABLE_CLIENT_STATUSES.has(status)) return false
  return failureCount < MAX_RETRIES
}
